export default "__VITE_ASSET__V47AnNV3__"